import React from 'react';
import AppConfirmActionButton from '../../common/General/AppConfirmActionButton';
import { notifyError } from '../Notifications/uiNotification';
import { useDebugContext } from '../../common/Debug';
import CmonReportsService from '../../services/cmon/CmonReportsService';
import { ConfirmActionButtonProps } from '@severalnines/bar-frontend-components/build/lib/General/ConfirmActionButton';
import { ReportItem } from './ReportsTable';

export default DeleteReportActionButton;
export type DeleteReportActionButtonProps = ConfirmActionButtonProps & {
    report: ReportItem;
    onSuccess?: () => void;
};

function DeleteReportActionButton({
    report,
    onSuccess,
    children,
    ...rest
}: DeleteReportActionButtonProps) {
    const { log } = useDebugContext();

    const handleConfirm = async () => {
        try {
            await CmonReportsService.removeErrorReport({
                cluster_id: report.clusterId,
                id: report.id,
            });
            onSuccess?.();
        } catch (e) {
            notifyError({ content: e.message });
            log.error(e);
        }
    };
    return (
        <AppConfirmActionButton
            critical={true}
            confirmTitle="You want to delete this report?"
            onConfirm={handleConfirm}
            {...rest}
        >
            {children || 'Delete'}
        </AppConfirmActionButton>
    );
}
